import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import Filter, { FilterValue } from 'components/Filter'
import Paper from 'components/Paper'
import { TableHeader } from 'components/Table'
import { cypressId } from 'features/inventory/ad-unit/forms/PrebidStackForm/utils'
import { BiddersTable } from './components/BiddersTable'

export const BiddersSection = (): React.JSX.Element => {
  const { t } = useTranslation(['features/adUnit', 'common'])
  const [filters, setFilters] = useState<FilterValue[]>([])

  const BiddersFilter = (
    <Filter
      id='biddersFilter'
      onChange={setFilters}
      placeholder={t('common:filter.search')}
      values={filters}
    />
  )

  return (
    <Paper data-cy={cypressId('bidders')}>
      <TableHeader
        description={t('form.prebidStack.bidders.list.description')}
        filter={BiddersFilter}
        title={t('form.prebidStack.bidders.list.title')}
      />

      <GapBox />

      <BiddersTable filters={filters} />
    </Paper>
  )
}
